import { faBan, faEdit } from '@fortawesome/free-solid-svg-icons';
import { Column, DataTable, TableActionButton } from 'components/DataTable';
import { useConfirmedCallback } from 'hooks/useConfirmedCallback';
import useMediaQuery from 'hooks/useMediaQuery';
import { useModal } from 'hooks/useModal';
import moment from 'moment';
import React, { useCallback, useMemo, useRef } from 'react';
import { useApi } from '../../../hooks/useApi';
import { BookingForm } from './SpaceBookingAssistant';
import { SpaceBookingDatesComponent } from './SpaceBookingList';

interface Props {}

export const UserSpaceBookingList: React.FunctionComponent<React.PropsWithChildren<React.PropsWithChildren<Props>>> = ({}: Props) => {
    const api = useApi();
    const [setModal] = useModal();
    const asyncList = useRef<any>(undefined);
    const isMobile = useMediaQuery('(max-width: 650px)');

    const handleCancelBooking = useConfirmedCallback((bookingId: number) => {
        void api({
            url: `booking/${bookingId}/cancel`,
            method: 'DELETE',
            onSuccess: () => asyncList.current?.reload()
        });
    });

    const handleEditSpaceBooking = useCallback(
        (booking: any) =>
            setModal({
                title: 'Buchung bearbeiten',
                content: (
                    <BookingForm
                        editMode
                        clubSlug={booking.clubSlug}
                        spaceGroup={null}
                        booking={booking}
                        callback={() => asyncList.current?.reload()}
                    />
                ),
                show: true
            }),
        [asyncList]
    );

    const columns = useMemo(
        (): Column[] => [
            !isMobile && { name: '#', uid: 'id' },
            {
                uid: 'spaces',
                name: 'Plätze',
                renderer(value) {
                    return (
                        <div>
                            {value?.map((space) => (
                                <span className="tw-block tw-font-thin" key={space.id}>
                                    {space.name}
                                </span>
                            ))}
                        </div>
                    );
                }
            },
            { name: 'Daten', uid: 'start', renderer: (_, item) => <SpaceBookingDatesComponent booking={item} /> },
            !isMobile && {
                name: 'Gebucht am',
                uid: 'created_at',
                renderer: (date) => moment(date).format('D.M.Y, H:mm')
            },
            { name: 'Optionen', uid: 'actions', align: 'end' }
        ],
        []
    );

    return (
        <DataTable
            asyncListRef={asyncList}
            hideSearchBar
            columns={columns}
            fetchUrl={'user/space-bookings'}
            tableProps={{ compact: false }}
            rowActions={(item) => (
                <TableActionButton.Container justify="flex-end">
                    {!item.cancelled_at && (
                        <>
                            <TableActionButton
                                color="warning"
                                icon={faEdit}
                                tooltip="Bearbeiten"
                                onPress={() => handleEditSpaceBooking(item)}
                            />
                            <TableActionButton
                                color="error"
                                icon={faBan}
                                tooltip="Stornieren"
                                onPress={() => handleCancelBooking(item.id)}
                            />
                        </>
                    )}
                </TableActionButton.Container>
            )}
        />
    );
};
